<template>
    <div class="ifk-mobile">

        <div v-show="createPDFFlag" style="position: fixed;width: 100%;height: 100%;z-index: 999;opacity: 0.9;background-color: #fff;">
        <div style="text-align: center;margin-top: 60px;">
            <img src="@/assets/pdf/hawkeye.jpg" style="width: 120px;height: 120px;">
            <div class="indexInfoDiv">
            <div style="font-size: 30px;margin-top: 15px;">弈客鹰眼5.0智能棋评</div>
            <div style="margin-top: 40px;font-size: 15px;line-height: 26px;">
                <div>{{text}}</div>
            </div>
            </div>
        </div>
        </div>

        <div class="content">
            <div :style="'width:' + boardWidth + 'px'" style="margin-left: 10px;">
                <div id="board" class="board" :style="'width:' + (boardWidth) + 'px'"></div>
            </div>
            <div class="database cf" :style="'width:' + (dbWidth) + 'px'" >
                <div class="game_info border-all ">
                    <div class="title flex space-between">
                        <div class="fs10  flex" style="align-items: center;">
                            <span>{{ gName }}</span>
                        </div>
                        <div class="fs10 flex">
                            {{ result.game_date }}
                        </div>
                    </div>
                    <div class="game_info_detail flex space-between">
                        <div style="position: relative;">
                            <img style="position: absolute;right: 0px;bottom: 5px;" class="img"
                                src="@/assets/blackstone.png">
                            <img v-if="move.b_rate > 30" src="@/assets/head/bhead3.png"
                                style="border-radius: 100%;width: 40px;">
                            <img v-else-if="move.b_rate > 10" src="@/assets/head/bhead2.png"
                                style="border-radius: 100%;width: 40px;">
                            <img v-else src="@/assets/head/bhead1.png" style="border-radius: 100%;width: 40px;">
                        </div>
                        <div style="flex-grow:1;padding: 0px 10px;">
                            <div class="flex space-between">
                                <div class="flex align-center nameOver" style="width: 35%;">
                                    <span class="fs11 ">{{ bPlayer }}</span>
                                </div>
                                <div class=" fuzadu"> {{ '复杂度 ' + move.score_stdev.toFixed(1) }}</div>
                                <div class="flex align-center nameOver" style="width: 35%;justify-content: flex-end;">
                                    <span class="fs11 ">{{ wPlayer }}</span>
                                </div>
                            </div>
                            <div class="flex space-between  fs10">
                                <div class="flex align-center"><span>提{{ bRemoveCount }}子</span></div>
                                <div>{{ curPath }}手/{{ allPath }}·{{ gResult }}</div>
                                <div class="flex align-center"><span>提{{ wRemoveCount }}子</span></div>
                            </div>
                            <div class="vs-line flex space-between" style="height: 10px;margin-top: 3px;">
                                <template v-if="move.w_rate != 100">
                                    <div class="vs-line-l fs9" :class="{ 'vs-line-l100': move.b_rate == 100 }"
                                        :style="{ width: move.b_rate + '%' }" style="line-height: 10px;">
                                        <template v-if="move.b_rate > 10">
                                            {{ move.b_rate.toFixed(1) }}
                                        </template>
                                    </div>
                                </template>
                                <template v-if="move.b_rate != 100">
                                    <div class="vs-line-r fs9" :class="{ 'vs-line-r100': move.w_rate == 100 }"
                                        :style="{ width: move.w_rate + '%' }" style="line-height: 10px;">
                                        <template v-if="move.w_rate > 10">
                                            {{ move.w_rate.toFixed(1) }}
                                        </template>
                                    </div>
                                </template>
                            </div>
                        </div>
                        <div style="position: relative;">
                            <img v-if="move.w_rate > 30" src="@/assets/head/whead3.png"
                                style="border-radius: 100%;width: 40px;">
                            <img v-else-if="move.w_rate > 10" src="@/assets/head/whead2.png"
                                style="border-radius: 100%;width: 40px;">
                            <img v-else src="@/assets/head/whead1.png" style="border-radius: 100%;width: 40px;">
                            <img style="position: absolute;left: 0px;bottom: 5px;" class="img"
                                src="@/assets/whitestone.png">
                        </div>
                    </div>
                </div>
                <div class="recommend border-all ">
                    <div class="row flex space-between title fs10">
                        <div style="padding-left:10px ;box-sizing: border-box;">推荐选点</div>
                        <div v-if="moveTimes">用时(秒)</div>
                        <div>胜率(%)</div>
                        <div>领先(目)</div>
                        <div v-if="reportType == 1">评分</div>
                    </div>
                    <div class="stoneList">
                        <template v-bind:key="item" v-for="(item) in recommendStone">
                            <div @click="recommendStoneTop(item)" v-on:mouseover="changeActive(item)"
                                v-on:mouseout="removeActive(item)"
                                class="row flex space-between  align-center fs12 recommendStone"
                                :class="{ recommendStoneSelected: recommendStoneSelected == item.stone, recommendStoneSelected1: hoverStone == item.stone }">
                                <div class="flex align-center">
                                    <img v-if="item.color == 1" style="width: 12px;padding: 0px 5px 0px 10px"
                                        src="@/assets/blackstone.png">
                                    <img v-else style="width: 12px;padding: 0px 5px 0px 10px" src="@/assets/whitestone.png">
                                    <span class="fs11" style="width: 20px;">{{ item.stone }}</span>

                                    <div v-if="item.mark" style="position: relative">
                                        <div class="shizhan " :class="{ hgroup: item.level == 1 }"
                                            :style="{ 'background-color': colorList[item.level] }">
                                            {{ item.mark }}
                                        </div>
                                    </div>
                                </div>
                                <div class="fs10" style="text-align: center;" v-if="moveTimes">
                                    <div v-if="item.move_time>0"
                                        :style="{'background-color': getTimeStdevC(item.move_time)}" 
                                        style="color:#fff;height: 12px;width: 40px;border-radius: 3px;margin: auto;line-height: 12px;">
                                        {{ item.move_time }}
                                    </div>
                                </div>
                                <div>
                                    <div class="vs-line flex space-between" style="max-width: 110px;">
                                        <div class="vs-line-l fs9" style="width: 50%;">
                                            <span v-if="item.color == 1"> {{ item.b_rate.toFixed(1) }}</span>
                                            <span v-else> {{ item.b_rate.toFixed(1) }}</span>
                                        </div>
                                        <div class="vs-line-r fs9" style="width: 50%;">
                                            <span v-if="item.color == 1"> {{ item.w_rate.toFixed(1) }}</span>
                                            <span v-else>{{ item.w_rate.toFixed(1) }}</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="fs10" style="text-align: center;">
                                    <template v-if="item.color == 1">
                                        <div v-if="item.an_result > 0" class="an_resultB">
                                            {{ Math.abs(item.an_result) }}
                                        </div>
                                        <div v-else-if="item.an_result < 0" class="an_resultW">
                                            {{ Math.abs(item.an_result) }}
                                        </div>
                                        <div v-else>0.0</div>
                                    </template>
                                    <template v-else>
                                        <div v-if="-item.an_result > 0" class="an_resultW">
                                            {{ Math.abs(item.an_result) }}
                                        </div>
                                        <div v-else-if="-item.an_result < 0" class="an_resultB">
                                            {{ Math.abs(item.an_result) }}
                                        </div>
                                        <div v-else>0.0</div>
                                    </template>
                                </div>
                                <div v-if="reportType == 1">{{ item.score.toFixed(1) }}</div>
                                
                            </div>
                        </template>
                    </div>
                </div>

                <div v-show="moreFlag" class="btn_list1">
                    <div>
                        <div v-if="reportType == 1 && result.status == 3" @click="boardFunc('pdf')" class="btn_div1">
                            查看PDF
                        </div>
                        <div @click="boardFunc('tryMove')" class="btn_div1" :class="{ 'btn_div1_selected': tryMoveFlag }">
                            试下
                        </div>
                        <div @click="boardFunc('score')" class="btn_div1" :class="{ 'btn_div1_selected': scoreFlag }">
                            领地
                        </div>
                        <div @click="boardFunc('marker')" class="btn_div1" :class="{ disableTest: tryMoveFlag }">
                            手数
                        </div>
                        <div @click="boardFunc('showStone')" class="btn_div1" :class="{ 'btn_div1_selected': showStone }">
                            不提示
                        </div>
                    </div>
                </div>


                <div class="btn_list flex">
                    <div v-on:mousedown="btntype = 'first'" v-on:mouseup="btntype = ''" @click="boardFunc('first')"
                        class="btn_div">
                        <img :class="{ btnSelected: btntype == 'first' }" src="@/assets/ifk/firstblue.png">
                    </div>
                    <div v-on:mousedown="btntype = 'previousfive'" v-on:mouseup="btntype = ''"
                        @click="boardFunc('previousfive')" class="btn_div">
                        <img :class="{ btnSelected: btntype == 'previousfive' }" src="@/assets/ifk/previousfiveblue.png">
                    </div>
                    <div v-on:mousedown="btntype = 'previous'" v-on:mouseup="btntype = ''" @click="boardFunc('previous')"
                        class="btn_div">
                        <img :class="{ btnSelected: btntype == 'previous' }" src="@/assets/ifk/previousblue.png">
                    </div>
                    <div v-on:mousedown="btntype = 'next'" v-on:mouseup="btntype = ''" @click="boardFunc('next')"
                        class="btn_div">
                        <img :class="{ btnSelected: btntype == 'next' }" src="@/assets/ifk/nextblue.png">
                    </div>
                    <div v-on:mousedown="btntype = 'nextfive'" v-on:mouseup="btntype = ''" @click="boardFunc('nextfive')"
                        class="btn_div"><img :class="{ btnSelected: btntype == 'nextfive' }"
                            src="@/assets/ifk/nextfiveblue.png">
                    </div>
                    <div v-on:mousedown="btntype = 'last'" v-on:mouseup="btntype = ''" @click="boardFunc('last')"
                        class="btn_div"><img :class="{ btnSelected: btntype == 'last' }" src="@/assets/ifk/lastblue.png">
                    </div>
                    <div v-on:mousedown="btntype = 'last'" v-on:mouseup="btntype = ''" @click="boardFunc('more')"
                        class="btn_div"><img :class="{ btnSelected: btntype == 'more' }" src="@/assets/ifk/more.png">
                    </div>
                    <div style="background-color: rgba(48, 19, 7, 0.5); color: #fff; border-radius: 4px; padding: 0px 5px; font-size: 14px;cursor: pointer;"
                     @click="boardFunc('infinite')">
                        无限算力
                    </div>
                </div>
                <div class="echarts_div border-all ">
                    <div class="tab_title fs12 ">
                        <div v-if="reportType != 2 || app_key == 'golinks_sgfbank'" @click="openChart(1)"
                            :class="{ tab_active: tabActive == 1 }">走势</div>
                        <div v-if="reportType != 2 && app_key != 'golinksmallnew'" @click="openChart(2)"
                            :class="{ tab_active: tabActive == 2 }">恶手</div>
                        <div v-if="reportType != 2" @click="openChart(3)"
                            :class="{ tab_active: tabActive == 3 }">吻合度</div>
                        <div v-if="reportType == 1" @click="openChart(4)" :class="{ tab_active: tabActive == 4 }">评分</div>
                        <div v-if="moveTimes" @click="openChart(21)" :class="{tab_active:tabActive==21}">决策</div>
                        <div v-if="reportType == 1" @click="openChart(5)" :class="{ tab_active: tabActive == 5 }">稳定性</div>
                        <div v-if="reportType == 2" @click="openChart(7)" :class="{ tab_active: tabActive == 7 }">疑问手</div>
                        <div v-if="reportType == 2 && app_key != 'golinks_sgfbank'" @click="openChart(9)"
                            :class="{ tab_active: tabActive == 9 }">好手报告</div>
                        <!-- <div v-if="reportType == 1" @click="openChart(8)" :class="{ tab_active: tabActive == 8 }">复杂度</div> -->
                        <div v-if="moveTimes || reportType == 1" @click="openChart(20)" :class="{ tab_active: tabActive == 20 }">用时</div>
                    </div>
                    <div class="tab_content " :style="'height:' + (echartsHeight) + 'px'">
                        <!-- 棋局走势 -->
                        <div v-show="tabActive == 1" style="height: 100%;">
                            <div style="width: 99%;height: 100%;" id="chartTrend"></div>
                        </div>
                        <!-- 棋局用时 -->
                        <div v-show="tabActive == 20" style="height: 100%;">
                            <div style="width: 99%;height: 100%;" id="chartMoveTimes"></div>
                        </div>
                        <!-- 决策质量 -->
                        <div v-show="tabActive == 21" class="flex echarts_content" style="height: 100%;">
                            <div class="btn" style="width: 13%;">
                                <div>
                                    <span @click="boardTypeChange(0)" :class="{ tab_active: boardType == 0 }">全盘</span>
                                    <span @click="boardTypeChange(1)" :class="{ tab_active: boardType == 1 }">布局</span>
                                    <span @click="boardTypeChange(2)" :class="{ tab_active: boardType == 2 }">中盘</span>
                                    <span @click="boardTypeChange(3)" :class="{ tab_active: boardType == 3 }">官子</span>
                                </div>
                                <div>
                                    <span @click="playerTypeChange(1)" :class="{ tab_active: playerType != 2 }">黑方</span>
                                    <span @click="playerTypeChange(2)" :class="{ tab_active: playerType == 2 }">白方</span>
                                </div>
                            </div>
                            <div id="decisionQuality" style="width: 87%;height: 100%;"></div>
                        </div>
                        <!-- 恶手分析 -->
                        <div v-show="tabActive == 2" class="flex echarts_content" style="height: 100%;">
                            <div class="btn" style="width: 13%;">
                                <div>
                                    <span @click="boardTypeChange(0)" :class="{ tab_active: boardType == 0 }">全盘</span>
                                    <span @click="boardTypeChange(1)" :class="{ tab_active: boardType == 1 }">布局</span>
                                    <span @click="boardTypeChange(2)" :class="{ tab_active: boardType == 2 }">中盘</span>
                                    <span @click="boardTypeChange(3)" :class="{ tab_active: boardType == 3 }">官子</span>
                                </div>
                                <div>
                                    <span @click="playerTypeChange(0)" :class="{ tab_active: playerType == 0 }">双方</span>
                                    <span @click="playerTypeChange(1)" :class="{ tab_active: playerType == 1 }">黑方</span>
                                    <span @click="playerTypeChange(2)" :class="{ tab_active: playerType == 2 }">白方</span>
                                </div>
                            </div>
                            <div id="badHand" style="width: 87%;height: 100%;"></div>
                        </div>
                        <!-- 吻合度 -->
                        <div v-show="tabActive == 3" class="flex echarts_content" style="height: 100%;position: relative;">
                            <div v-if="reportType == 1" @click="switchEye()" class="switchMode" style="left: 10px;">
                                {{ eyeModeText }}</div>

                            <div class="btn" style="width: 13%;">
                                <div>
                                    <span @click="boardTypeChange(0)" :class="{ tab_active: boardType == 0 }">全盘</span>
                                    <span @click="boardTypeChange(1)" :class="{ tab_active: boardType == 1 }">布局</span>
                                    <span @click="boardTypeChange(2)" :class="{ tab_active: boardType == 2 }">中盘</span>
                                    <span @click="boardTypeChange(3)" :class="{ tab_active: boardType == 3 }">官子</span>
                                </div>
                            </div>
                            <div id="hitHand" style="width: 87%;height: 100%;"></div>
                        </div>

                        <!-- 鹰眼评分 -->
                        <div v-show="tabActive == 4" class="flex echarts_content" style="height: 100%;">
                            <div class="btn" style="width: 13%;">
                                <div>
                                    <span @click="boardTypeChange(0)" :class="{ tab_active: boardType == 0 }">全盘</span>
                                    <span @click="boardTypeChange(1)" :class="{ tab_active: boardType == 1 }">布局</span>
                                    <span @click="boardTypeChange(2)" :class="{ tab_active: boardType == 2 }">中盘</span>
                                    <span @click="boardTypeChange(3)" :class="{ tab_active: boardType == 3 }">官子</span>
                                </div>
                            </div>
                            <div id="scoreChart" style="width: 87%;height: 100%;"></div>
                        </div>

                        <!-- 统计学 -->
                        <div v-show="tabActive == 5" class="flex echarts_content" style="height: 100%; position: relative;">
                            <div @click="switchTongji()" class="switchMode" style="left: 10px;">{{ tongjiText }}</div>
                            <div v-show="tongjiFlag == 2" style="width: 100%;height: 100%;" id="statisticsBox"></div>

                            <div v-show="tongjiFlag == 1" class="btn" style="width: 13%;">
                                <div>
                                    <span @click="boardTypeChange(0)" :class="{ tab_active: boardType == 0 }">全盘</span>
                                    <span @click="boardTypeChange(1)" :class="{ tab_active: boardType == 1 }">布局</span>
                                    <span @click="boardTypeChange(2)" :class="{ tab_active: boardType == 2 }">中盘</span>
                                    <span @click="boardTypeChange(3)" :class="{ tab_active: boardType == 3 }">官子</span>
                                </div>
                            </div>
                            <div v-show="tongjiFlag == 1" id="stableLine" style="width: 87%;height: 100%;"></div>

                        </div>
                        <!-- 恶手模式 -->
                        <div v-show="tabActive == 7" class="flex echarts_content" style="height: 100%;">
                            <div class="btn" style="width: 13%;">
                                <div>
                                    <span @click="switchBad()" :class="{ tab_active: reportType == 2 }">{{ showBadGroup ?
                                        '筛选' : '返回'
                                    }} </span>
                                </div>
                                <div>
                                    <span @click="playerTypeChange(0)" :class="{ tab_active: playerType == 0 }">双方</span>
                                    <span @click="playerTypeChange(1)" :class="{ tab_active: playerType == 1 }">黑方</span>
                                    <span @click="playerTypeChange(2)" :class="{ tab_active: playerType == 2 }">白方</span>
                                </div>
                            </div>
                            <div style="width: 87%;height: 100%;overflow-y: auto;">
                                <div v-if="!showBadGroup" class="badList">
                                    <div @click="ListGoTo(item)" v-bind:key="item.id" v-on:mouseover="badActive = item.move"
                                        v-on:mouseout="badActive = ''" v-for="item in badList" class="badItem"
                                        :class="{ recommendStoneSelected: badActive == item.move }">
                                        <text class="text1">第<text style="font-size: 14px;padding: 0px 2px">{{ item.move
                                        }}</text>手</text>
                                        <text class="text2">
                                            <text v-if="!item.bad_tag"
                                                style="padding: 0px 13px;font-size: 12px;border-radius: 3px;"
                                                :style="{ 'background-color': colorList[item.level] }"> {{ item.mark
                                                }}</text>
                                            <text v-else style="padding: 0px 13px;font-size: 12px;border-radius: 3px;"
                                                :style="{ 'background-color': colorList[item.level] }">
                                                {{ item.bad_tag }}</text>
                                        </text>
                                        <text class="text3">{{ item.rate_diff.toFixed(1) + '%' }}</text>
                                        <text class="text4">{{ item.an_diff.toFixed(1) + '目' }}</text>
                                    </div>
                                </div>
                                <div v-else class="badList">
                                    <div @click="badGroupTop(item)" v-bind:key="item.id"
                                        v-on:mouseover="badGroupActive = item.key" v-on:mouseout="badGroupActive = ''"
                                        v-for="item in bad_group" class="badItem"
                                        :class="{ recommendStoneSelected: badGroupActive == item.key }">
                                        <text class="text1">
                                            <text v-if="!item.bad_tag"
                                                style="padding: 0px 13px;font-size: 12px;border-radius: 3px;"
                                                :style="{ 'background-color': colorList[item.level] }"> {{ item.mark
                                                }}</text>

                                            <text v-else
                                                style="padding: 0px 13px;font-size: 12px;border-radius: 3px;background-color:#d43dea ;">
                                                {{ item.bad_tag }}</text>
                                        </text>
                                        <text class="text2">共<text style="font-size: 14px;padding: 0px 2px">{{ item.count
                                        }}</text>手</text>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- 复杂度 -->
                        <div v-show="tabActive == 8" style="height: 100%;position: relative;">
                            <div style="position: absolute;width: 100%;text-align: center;top: 10px;">
                                <div class="fs11" >复杂度越高代表当前盘面AI计算量消耗越高，往往与激烈攻杀相关。</div>
                            </div>
                            <div style="width: 99%;height: 100%;" id="complexChart"></div>
                        </div>
                        <!-- 好手报告 -->
                        <div v-show="tabActive == 9" class="flex echarts_content" style="height: 100%;">
                            <div class="btn" style="width: 13%;">
                                <div>
                                    <span @click="switchBad()" :class="{ tab_active: reportType == 2 }">筛选</span>
                                </div>
                                <div>
                                    <span @click="playerTypeChange(0)" :class="{ tab_active: playerType == 0 }">双方</span>
                                    <span @click="playerTypeChange(1)" :class="{ tab_active: playerType == 1 }">黑方</span>
                                    <span @click="playerTypeChange(2)" :class="{ tab_active: playerType == 2 }">白方</span>
                                </div>
                            </div>
                            <div style="width: 87%;height: 100%;overflow-y: auto;">
                                <div v-if="!showGoodGroup" class="badList">
                                    <div @click="ListGoTo(item)" v-bind:key="item.id"
                                        v-on:mouseover="goodActive = item.move" v-on:mouseout="goodActive = ''"
                                        v-for="item in goodList" class="badItem"
                                        :class="{ recommendStoneSelected: goodActive == item.move }">
                                        <text class="text1">第<text style="font-size: 14px;padding: 0px 2px">{{ item.move
                                        }}</text>手</text>
                                        <text class="text2">
                                            <text v-if="!item.good_tag"
                                                style="padding: 0px 13px;font-size: 12px;border-radius: 3px;"
                                                :style="{ 'background-color': colorList[item.level] }"> {{ item.mark
                                                }}</text>
                                            <text v-else
                                                style="padding: 0px 13px;font-size: 12px;border-radius: 3px;background-color:#d43dea ;">
                                                {{ item.good_tag }}</text>
                                        </text>
                                        <text class="text3">{{ item.rate_diff.toFixed(1) + '%' }}</text>
                                        <text class="text4">{{ item.an_diff.toFixed(1) + '目' }}</text>
                                    </div>
                                </div>
                                <div v-else class="badList">
                                    <div @click="GoodGroupTop(item)" v-bind:key="item.id"
                                        v-on:mouseover="goodGroupActive = item.key" v-on:mouseout="goodGroupActive = ''"
                                        v-for="item in good_group" class="badItem"
                                        :class="{ recommendStoneSelected: goodGroupActive == item.key }">
                                        <text class="text1">
                                            <text v-if="!item.good_tag"
                                                style="padding: 0px 13px;font-size: 12px;border-radius: 3px;"
                                                :style="{ 'background-color': colorList[item.level] }"> {{ item.mark
                                                }}</text>
                                            <text v-else
                                                style="padding: 0px 13px;font-size: 12px;border-radius: 3px;background-color:#d43dea ;">
                                                {{ item.good_tag }}</text>
                                        </text>
                                        <text class="text2">共<text style="font-size: 14px;padding: 0px 2px">{{ item.count
                                        }}</text>手</text>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>


    </div>
</template>
  
<script>
import ifkMobile from '@/js/index.js'

export default ifkMobile
</script>
  
<style scoped>
.header {
    height: 50px;
    background-color: rgba(50, 50, 50, 0.5);
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0px 20px;
}

.header_l {
    display: flex;
    align-items: center;
}

.header_l_img {
    width: 35px;
    height: 35px;
    padding: 0px 20px;
}

.content {
    display: flex;
    justify-content: center;
}

.board_content {
    padding: 10px 10px 10px 20px;
}

.board {
    background: url("~@/libs/ggo/hawk_board.png") no-repeat;
    background-position: center;
    background-size: cover;
    margin: auto;
}

.database {
    width: 50%;
    padding: 0px 10px 0px 10px;
    position: relative;
}

.game_info {
    border-radius: 10px;
    background-color: rgba(48, 19, 7, 0.5);
    width: 100%;
    position: relative;
}

.game_info>.title {
    border-top-left-radius: 6px;
    border-top-right-radius: 6px;
    height: 15px;
    padding: 0px 10px;
    align-items: center;
}

.game_info_detail {
    padding: 0px 10px 0px 10px;
}

.game_info_detail .img {
    width: 10px;
    height: 10px;
}


.recommend {
    border-radius: 10px;
    background-color: rgba(48, 19, 7, 0.5);
    width: 100%;
    margin-top: 5px;
    box-sizing: border-box;
}

.stoneList {
    overflow-y: auto;
    box-sizing: border-box;
    height: 60px;
}

.recommend>.title {
    height: 20px !important;
    line-height: 20px !important;
}

.recommend .row {
    height: 20px;
    line-height: 32px;
    font-size: 14px;
    cursor: pointer;
}

.recommend .row> :nth-child(1) {
    width: 20%;
}

.recommend .row> :nth-child(2) {
    width: 20%;
    text-align: center;
}

.recommend .row> :nth-child(3) {
    width: 20%;
    text-align: center;
}

.recommend .row> :nth-child(4) {
    width: 20%;
    text-align: center;
}

.recommend .row> :nth-child(5) {
    width: 20%;
    text-align: center;
}

.vs-line {
    margin: auto;
    height: 10px;
}

.btn_list {
    justify-content: space-around;
    display: flex;
    align-items: center;
}

.btn_list>.btn_div {
    font-size: 12px;
    text-align: center;
    cursor: pointer;
    width: 30px;
    height: 30px;
    padding-top: 5px;
}

.btnSeleted {
    background: rgba(255, 255, 255, 0.35);
    border-radius: 4px;
}

.btn_list>.btn_div>img {
    width: 25px;
    height: 25px;
}

.btnSelected {
    width: 28px !important;
    height: 28px !important;
    margin: 1px;
}

.echarts_div {
    width: 100%;
    border-radius: 10px;
    background-color: rgba(48, 19, 7, 0.5);
    box-sizing: border-box;
}

.tab_title {
    display: flex;
    height: 26px;
    line-height: 26px;
    align-items: center;
    justify-content: space-around;
}

.tab_title div {
    width: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 18px;
    border-radius: 15px;
}

.tab_active {
    background: #fff !important;
    color: #834827 !important;
}

.tab_content {
    width: 100%;
}

.echarts_content {
    position: relative;
}

.echarts_content>.btn {
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    align-items: center;

}

.echarts_content>.btn>div>span {
    display: block;
    width: 30px;
    height: 12px;
    border-radius: 12px;
    color: #fff;
    font-size: 10px;

    box-sizing: border-box;
    cursor: pointer;
    border: 0.5px solid #fff;
    margin-top: 5px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.switchMode {
    position: absolute;
    font-size: 10px;
    background: #fff !important;
    color: #834827 !important;
    border-radius: 3px;
    padding: 0px 2px;
    top: 10px;
    z-index: 999;
}

.scoreResult {
    height: 100%;
    width: 100%;
    background-color: rgba(0, 0, 0, 0.8);
    position: absolute;
    z-index: 999;
    border-radius: 10px;
    text-align: center;
}

.recommendStone {
    padding-right: 10px;
}

.recommendStoneSelected {
    background-color: rgba(255, 255, 255, 0.25);
}

.recommendStoneSelected1 {
    background-color: rgba(255, 255, 255, 0.25);
}

.disableBtn {
    filter: grayscale(100%) brightness(80%);

}

.disableTest {
    color: #808080;
}

.bg1 {
    background: url("~@/assets/bg1.png") no-repeat;
    background-position: center;
    background-size: cover;
}

.bg2 {
    background: url("~@/assets/bg2.png") no-repeat;
    background-position: center;
    background-size: cover;
}

.bg3 {
    background: url("~@/assets/bg3.png") no-repeat;
    background-position: center;
    background-size: cover;
}


.header_r {
    font-size: 12px;
    color: rgba(255, 255, 255, 0.7);
}

.tag {
    background: rgba(255, 255, 255, 0.8);
    padding: 0px 5px;
    height: 14px;
    border-radius: 2px;
    color: #000;
    text-align: center;
    line-height: 14px;
    margin-right: 5px;
}

.shizhan {
    height: 15px;
    line-height: 15px;
    font-size: 10px;
    width: 40px;
    text-align: center;
    border-radius: 2px;
    margin-left: 5px;
}

.shizhanBorder {
    border-radius: 3px;
    box-sizing: border-box;
    border: .5px solid red;
}


.hgroup:before {
    content: "";
    position: absolute;
    left: 4px;
    /* top: 7px; */
    width: 5px;
    height: 16px;
    background-color: rgba(236, 236, 236, .5);
    /* -webkit-transform: rotate(-45deg);
    -moz-transform: rotate(-45deg);
    -ms-transform: rotate(-45deg);
    -o-transform: rotate(-45deg);
    transform: rotate(-45deg); */
    -webkit-animation: searchLights 1.2s ease-out infinite;
    -o-animation: searchLights 1.2s ease-out infinite;
    animation: searchLights 1.2s ease-out infinite;
}

@-webkit-keyframes searchLights {
    0% {
        left: 5px;
    }

    100% {
        left: 50px;
    }
}

@-o-keyframes searchLights {
    0% {
        left: 5px;
    }

    100% {
        left: 50px;
    }
}

@-moz-keyframes searchLights {
    0% {
        left: 5px;
    }

    100% {
        left: 50px;
    }
}

.badList {
    display: flex;
    flex-direction: column;
    /* justify-content: space-evenly; */
    height: 100%;
    width: 90%;
    padding: 5px 0px 5px 0px;
    box-sizing: border-box;
}

.badItem {
    display: flex;
    font-size: 12px;
    align-items: center;
    padding: 0px 30px;
    justify-content: space-around;
    height: 25px;
}

.text1 {
    width: 25%;
    font-size: 12px;
}

.text2 {
    width: 25%;
    text-align: center;
}

.text3 {
    width: 25%;
    text-align: center;
}

.text4 {
    width: 25%;
    text-align: right;
}

.fuzadu {
    font-size: 10px;
    background-color: #ffffff;
    color: #834827;
    padding: 0px 4px;
    height: 24rpx;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 26px;
}

.ifk-mobile {
    background: url(../assets/ifkbg1.png) no-repeat center;
    background-size: cover;
    height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow-y: hidden;
    overflow-x: auto;
}

.an_resultB {
    background-color: black;
    color: #fff;
    height: 12px;
    width: 50px;
    border-radius: 3px;
    margin: auto;
    line-height: 12px;
}

.an_resultW {
    background-color: white;
    color: black;
    height: 12px;
    width: 50px;
    border-radius: 3px;
    margin: auto;
    line-height: 12px;
}


.btn_list1 {
    position: absolute;
    background-color: rgba(48, 19, 7, 0.9);
    border-radius: 6px;
    padding: 8px;
    top: 35px;
    right: 10px;
}

.btn_list1 .btn_div1 {
    width: 50px;
    height: 20px;
    font-size: 10px;
    text-align: center;
    line-height: 20px;
}

.btn_div1_selected {
    background: #fff;
    color: #834827;
    border-radius: 20px;
}


.vs-line-l {
    background-color: #e0534c;
    width: 30%;
    border-top-left-radius: 10px;
    border-bottom-left-radius: 10px;
    text-align: center;
    line-height: 10px;
    color: #fff;
  }

  .vs-line-r {
    background-color: #3f85cf;
    width: 70%;
    border-top-right-radius: 10px;
    border-bottom-right-radius: 10px;
    text-align: center;
    line-height: 10px;
    color: #fff;
  }

  .vs-line-r100 {
    border-top-left-radius: 10px;
    border-bottom-left-radius: 10px;
  }

  .vs-line-l100 {
    border-top-right-radius: 10px;
    border-bottom-right-radius: 10px;
  }
  .nameOver{
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    -moz-text-overflow: ellipsis;
  }
</style>